<template>
    <div>
        <form-wrapper @form-submit="submit">
            <form-row>
                <form-cell :width="dateWidth">
                    <datepicker-input
                        ref="date"
                        :formData="data"
                        valuePath="date"
                        :placeholder="$t('forms.reservations.reservation_filter.fields.date_from.placeholder')"
                        :prefillValue="date"
                        @date-changed="dateChanged"
                        @keypress.enter.prevent
                    ></datepicker-input>
                </form-cell>
                <form-cell v-if="locations.length > 1" width="half">
                    <select-input
                        :formData="data"
                        :isNullable="true"
                        valuePath="locationId"
                        :placeholder="$t('forms.reservations.reservation_filter.fields.location.placeholder')"
                        :options="locationOptions"
                        @change="locationChange"
                        @clear="clearLocation(event)"
                    ></select-input>
                </form-cell>
            </form-row>
        </form-wrapper>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import dayjs from 'dayjs'

    export default {
        mixins: [FormMixin],

        props: {
            prefill: { type: Object, default: undefined },
            locations: { type: Array, default: undefined },
        },

        data() {
            return {
                date: undefined,
            }
        },

        computed: {
            locationOptions() {
                return this.locations.map((location) => ({
                    label: location.address,
                    value: location.id,
                }))
            },

            dateWidth() {
                return this.locations.length > 1 ? 'half' : ''
            },
        },

        methods: {
            dateChanged(value) {
                if (value !== undefined) {
                    this.setValue('date', value)
                } else {
                    this.setValue('date', dayjs.utc().format('YYYY-MM-DD'))
                }
                this.submit()
            },

            locationChange({ path, value }) {
                this.change({ path, value })
                this.submit()
            },

            clearLocation() {
                delete this.data.locationId
                this.submit()
            },

            submit() {
                const query = {}
                if (this.data.date) {
                    query.date = this.data.date
                }

                if (this.data.locationId) {
                    query.locationId = this.data.locationId
                }

                this.emitEvent({ name: 'filter-change', payload: query })
            },
        },

        mounted() {
            if (this.prefill.date) {
                this.date = this.prefill.date
            }
        },
    }
</script>
